import React, { useState, useCallback } from 'react';
import { Search } from 'lucide-react';

export default function SearchBar({ onSearch, placeholder = "Rechercher..." }) {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = useCallback((e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  }, [onSearch]);

  return (
    <div className="relative">
      <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full pl-12 pr-4 py-3 border-2 border-gray-200 rounded-xl focus:border-red-600 focus:outline-none transition"
      />
    </div>
  );
}
